module.exports = __webpack_public_path__ + "static/img/indexImg2.bf0d24a4.png";